export interface QueueMotion {
  tapeMs: number;
  tapeScale: number;
  tapeBlur: number;
  tapeBounce: number;
  enterMs: number;
  enterScale: number;
  enterBlur: number;
  exitMs: number;
  exitScale: number;
  exitBlur: number;
  hoverMs: number;
  hoverScale: number;
  hoverSpin: number;
  hoverAxis: 'x' | 'y' | 'z';
  cardMs: number;
  cardScale: number;
  cardBlur: number;
  cardRise: number;
  cardShake: number;
  cardCascade: number;
}
export const DEFAULT_QUEUE_MOTION: QueueMotion = {
  tapeMs: 450,
  tapeScale: 0.86,
  tapeBlur: 1.5,
  tapeBounce: 0,
  enterMs: 420,
  enterScale: 0.5,
  enterBlur: 10,
  exitMs: 360,
  exitScale: 0.45,
  exitBlur: 12,
  hoverMs: 400,
  hoverScale: 1.12,
  hoverSpin: 360,
  hoverAxis: 'y',
  cardMs: 480,
  cardScale: 0.92,
  cardBlur: 8,
  cardRise: 28,
  cardShake: 0,
  cardCascade: 56,
};
export function clampMotion(
  value: Partial<QueueMotion> | null | undefined,
): QueueMotion {
  const raw = value && typeof value === 'object' ? value : {};
  const num = (
    key: Exclude<keyof QueueMotion, 'hoverAxis'>,
    min: number,
    max: number,
  ) => {
    const n = Number(raw[key]);
    return Number.isFinite(n)
      ? Math.min(max, Math.max(min, n))
      : DEFAULT_QUEUE_MOTION[key];
  };
  return {
    tapeMs: num('tapeMs', 80, 2000),
    tapeScale: num('tapeScale', 0.4, 1),
    tapeBlur: num('tapeBlur', 0, 20),
    tapeBounce: num('tapeBounce', 0, 1),
    enterMs: num('enterMs', 80, 2000),
    enterScale: num('enterScale', 0.2, 1.4),
    enterBlur: num('enterBlur', 0, 24),
    exitMs: num('exitMs', 80, 2000),
    exitScale: num('exitScale', 0.2, 1.4),
    exitBlur: num('exitBlur', 0, 24),
    hoverMs: num('hoverMs', 80, 2000),
    hoverScale: num('hoverScale', 1, 1.6),
    hoverSpin: num('hoverSpin', 0, 360),
    hoverAxis: axisOf(raw.hoverAxis),
    cardMs: num('cardMs', 80, 2000),
    cardScale: num('cardScale', 0.6, 1.2),
    cardBlur: num('cardBlur', 0, 24),
    cardRise: num('cardRise', 0, 80),
    cardShake: num('cardShake', 0, 24),
    cardCascade: num('cardCascade', 0, 200),
  };
}
function axisOf(value: unknown): QueueMotion['hoverAxis'] {
  return value === 'x' || value === 'z' ? value : 'y';
}
export function motionEase(bounce: number) {
  const amount = Math.min(1, Math.max(0, bounce));
  const x1 = (0.4 - 0.18 * amount).toFixed(2);
  const y1 = (1.56 * amount).toFixed(2);
  const x2 = (0.2 + 0.12 * amount).toFixed(2);
  return 'cubic-bezier(' + x1 + ', ' + y1 + ', ' + x2 + ', 1)';
}
